import { createAction, props } from '@ngrx/store';
import { MgError } from '../../models/error.model';
import { QueryParamsState } from '../query-params';
import {
  ConfirmRefundRequest,
  DestinationCountryData,
  FeeLookUpRequest,
  PaymentMethod,
} from './types';

export enum TransactionActions {
  adddestinationCountryData = '[Transaction] destinationCountryData',
  setPaymentMethod = '[Transaction] setPaymentMethod',
  feeLookup = '[Transaction] feeLookup',
  feeLookupSuccess = '[Transaction] feeLookupSuccess',
  feeLookupFailed = '[Transaction] feeLookup Failed',
  sendValidate = '[Transaction] SendValidate ',
  sendValidateSuccess = '[Transaction] SendValidate Success',
  sendValidateFailed = '[Transaction] SendValidate Failed',
  sendCommit = '[Transaction] SendCommit',
  sendCommitSuccess = '[Transaction] SendCommit Success',
  sendCommitFailed = '[Transaction] SendCommit Failed',
  transactionStatus = '[Transaction] transactionStatus ',
  transactionStatusSuccess = '[Transaction] transactionStatus Success',
  transactionStatusFailed = '[Transaction] transactionStatus Failed',
  getTransactionRefund = '[Transaction] get refund',
  getRefundSuccess = '[Transaction] getRefundSuccess',
  getRefundFailed = '[Transaction] getRefundFailed',
  confirmTransactionRefund = '[Transaction] confirm transaction refund',
  refundTransactionSuccess = '[Transaction] Refund success',
  refundTransactionFailed = '[Transaction] Refund failed',
  prepareTransaction = '[Transaction] Prepare transaction',
  SELECTED_LOCATION = '[Transaction] Selected Location',
  CLEAR_SELECTED_LOCATION = '[Transaction] Clear Selected Location',
}

export const AdddestinationCountryData = createAction(
  TransactionActions.adddestinationCountryData,
  props<{ destinationCountryData: DestinationCountryData }>()
);

export const setPaymentMethod = createAction(
  TransactionActions.setPaymentMethod,
  props<{ paymentMethod: PaymentMethod }>()
);

export const FeeLookup = createAction(
  TransactionActions.feeLookup,
  props<{ feeLookupRequest: FeeLookUpRequest; endpoint: string }>()
);

export const FeeLookupSuccess = createAction(
  TransactionActions.feeLookupSuccess,
  props<{ feeLookupResponse: {} }>()
);

export const FeeLookupFailed = createAction(
  TransactionActions.feeLookupFailed,
  props<{ error: MgError }>()
);

export const SendValidate = createAction(
  TransactionActions.sendValidate,
  props<{ transactionId: string | number; payload: any; endpoint: string }>()
);

export const SendValidateSuccess = createAction(
  TransactionActions.sendValidateSuccess,
  props<{ sendValidateResponse: any }>()
);
export const SendValidateFailed = createAction(
  TransactionActions.sendValidateFailed,
  props<{ error: MgError }>()
);

export const SendCommit = createAction(
  TransactionActions.sendCommit,
  props<{
    transactionId: string | number;
    isQrCodeRequired: boolean;
    locale: string;
    endpoint: string;
  }>()
);

export const SendCommitSuccess = createAction(
  TransactionActions.sendCommitSuccess,
  props<{ sendCommitResponse: any }>()
);
export const SendCommitFailed = createAction(
  TransactionActions.sendCommitFailed,
  props<{ error: MgError }>()
);

export const TransactionStatus = createAction(
  TransactionActions.transactionStatus,
  props<{
    transactionId: string | number;
    refNumber: string | number;
    endpoint: string;
  }>()
);

export const TransactionStatusSuccess = createAction(
  TransactionActions.transactionStatusSuccess,
  props<{ transactionStatusResponse: any }>()
);

export const TransactionStatusFailed = createAction(
  TransactionActions.transactionStatusFailed,
  props<{ error: MgError }>()
);

export const GetTransactionRefund = createAction(
  TransactionActions.getTransactionRefund,
  props<{
    transactionId: string | number;
    refundCancelReason: string;
    endpoint: string;
  }>()
);

export const GetRefundSuccess = createAction(
  TransactionActions.getRefundSuccess,
  props<{ getRefundResponse: any }>()
);

export const GetRefundFailed = createAction(
  TransactionActions.getRefundFailed,
  props<{ error: MgError }>()
);

export const ConfirmTransactionRefund = createAction(
  TransactionActions.confirmTransactionRefund,
  props<{
    transactionId: string | number;
    payload: ConfirmRefundRequest;
    endpoint: string;
  }>()
);

export const ConfirmRefundSuccess = createAction(
  TransactionActions.refundTransactionSuccess,
  props<{ confirmRefundResponse: any }>()
);

export const ConfirmRefundFailed = createAction(
  TransactionActions.refundTransactionFailed,
  props<{ error: MgError }>()
);

export const PrepareTransaction = createAction(
  TransactionActions.prepareTransaction,
  props<{ queryParams: QueryParamsState }>()
);

export const SetLocationActionTrns = createAction(
  TransactionActions.SELECTED_LOCATION,
  props<{ selectedLocation: any }>()
);

export const ClearSelectedLocationAction = createAction(
  TransactionActions.CLEAR_SELECTED_LOCATION
);
